import { blobToBase64, ChakraV3, FileInput, readResizedImage } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props extends Omit<ChakraV3.AvatarProps, 'name'> {
  name: string;
  username?: string;
  direction?: 'row' | 'column';
  isDisabled?: boolean;
}

export const HookedAvatarUploader = (props: Props) => {
  const { name, username, size, direction, isDisabled } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  const onChange = React.useCallback(
    async (files: File[]) => {
      const file = P.first(files);
      if (file) {
        const image = await readResizedImage(file, { maxWidth: 96, maxHeight: 96 });
        const base64 = await blobToBase64(image);
        inputProps.onChange(base64);
      } else {
        inputProps.onChange(null);
      }
    },
    [inputProps.onChange],
  );

  return (
    <ChakraV3.Stack gap={1} direction={direction} align='center'>
      <ChakraV3.Avatar name={username} size={size} src={inputProps.value} bg='gray.300' />
      {inputProps.value ? (
        <ChakraV3.Button
          variant='plain'
          size='xs'
          onClick={() => onChange([])}
          disabled={isDisabled}
        >
          Remove
        </ChakraV3.Button>
      ) : (
        <FileInput
          files={inputProps.value}
          onFilesChange={onChange}
          multiple={false}
          variant='plain'
          size='xs'
          disabled={isDisabled}
        >
          Choose
        </FileInput>
      )}
    </ChakraV3.Stack>
  );
};
